import { Outlet } from 'react-router';
import { lazy, Suspense } from 'react';

import { ExaminationLayout } from 'src/layouts/examination';

import { LoadingScreen } from 'src/components/loading-screen';

const UserCertificateOverviewPage = lazy(
  () => import('src/pages/examination/user-certificate-overview')
);

export const mandatoryUnitRoutes = [
  {
    path: 'mandatory-unit',
    element: (
      <ExaminationLayout>
        <Suspense fallback={<LoadingScreen />}>
          <Outlet />
        </Suspense>
      </ExaminationLayout>
    ),
    children: [
      {
        path: ':id/user-certificate-overview',
        element: <UserCertificateOverviewPage />,
      },
    ],
  },
];
